// utils/schema.js (or .ts)
const ATTR = 'data-ld-owned';
export const injectSchema = (schemaData) => {
    document
        .querySelectorAll(`script[type="application/ld+json"][${ATTR}]`)
        .forEach(s => s.remove());
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute(ATTR, 'true');
    script.textContent = JSON.stringify(schemaData, null, 2);
    document.head.appendChild(script);
};
export const removeSchema = () => {
    document
        .querySelectorAll(`script[type="application/ld+json"][${ATTR}]`)
        .forEach(s => s.remove());
};
/**
 * Inject raw meta tag HTML string (e.g. from backend) into <head>.
 * Each injected <meta> will get `data-ld-owned="true"`, so we can remove them later.
 * This version is resilient to malformed attributes caused by unescaped quotes.
 */
export const injectMetaFromString = (metaHtml) => {
    // Clean up old meta tags added by us
    document.querySelectorAll(`meta[${ATTR}]`).forEach(m => m.remove());
    if (!metaHtml)
        return;
    // Parse string into DOM (tolerant, but may produce invalid attribute names)
    const parser = new DOMParser();
    const doc = parser.parseFromString(metaHtml, 'text/html');
    // Only copy known-safe attributes to avoid "String contains an invalid character"
    const ALLOWED_ATTRS = new Set([
        'name',
        'property',
        'content',
        'http-equiv',
        'charset',
        'media'
    ]);
    const metas = doc.querySelectorAll('meta');
    metas.forEach((meta) => {
        try {
            const clone = document.createElement('meta');
            clone.setAttribute(ATTR, 'true');
            // Copy only whitelisted attributes if they exist and are valid
            let copied = false;
            ALLOWED_ATTRS.forEach((attrName) => {
                if (meta.hasAttribute(attrName)) {
                    const val = meta.getAttribute(attrName);
                    // Skip empty/null values
                    if (val != null && val !== '') {
                        // setAttribute on allowed names is safe
                        clone.setAttribute(attrName, val);
                        copied = true;
                    }
                }
            });
            // If nothing meaningful was copied (e.g., fully malformed tag), skip it
            if (!copied)
                return;
            // Minimal validity check: must have either identifying attr or charset/http-equiv
            const hasIdentifier = clone.hasAttribute('name') ||
                clone.hasAttribute('property') ||
                clone.hasAttribute('charset') ||
                clone.hasAttribute('http-equiv');
            if (!hasIdentifier)
                return;
            document.head.appendChild(clone);
        }
        catch (e) {
            // One bad meta should never break the batch
            console.warn('Skipping malformed meta:', meta.outerHTML, e);
        }
    });
};
/** Remove only our injected meta tags */
export const removeMeta = () => {
    document.querySelectorAll(`meta[${ATTR}]`).forEach(m => m.remove());
};
